import { DISHOP_HUBRISE_ID, HUBRISE_DOMAIN } from '../constants/hubrise';
import store from '../utils/store';
import { getIdToken } from './firebase';
import { sendDeleteRequest } from '../utils/apiService';
import { API_DISCONNECT_HUBRISE } from '../constants';

export const connectToHubrise = redirectUri => {
  const { generalConfig = {}, shop = {} } = store.getState().firebaseRealTime;
  const { name } = generalConfig;
  const { name: shopName } = shop;
  return `${HUBRISE_DOMAIN}/oauth2/v1/authorize?redirect_uri=${redirectUri}&client_id=${DISHOP_HUBRISE_ID}&scope=location[orders.write,customer_list.write,catalog.write]&country=FR&account_name=${name}${shopName !== name ? `&location_name=${shopName}` : ''
    }`;
};

export const disconnectFromHubrise = async () => {
  const { shopId } = store.getState().user;
  const idToken = await getIdToken();
  await sendDeleteRequest(
    API_DISCONNECT_HUBRISE,
    {
      shopId
    },
    { Authorization: `Bearer ${idToken}` }
  );
};
